// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"f841463a","498":"8b397452","513":"ae19ab0d"}[chunkId] + ".chunk.js";
};